import { buildImage } from '@caritas/ui';
import { memoize } from 'lodash';

import { assetUrl } from '../utils/assets';

type MapImageProps = {
  image?: ImageFragment;
  preset:
    | 'header_landscape'
    | 'header_portrait'
    | 'quote'
    | 'content'
    | 'carousel'
    | 'carousel_vertical'
    | 'teaser'
    | 'file_list'
    | 'background_story'
    | 'background_story_portrait'
    | 'image_story'
    | 'collage_story_small'
    | 'collage_story_big'
    | 'contact_box'
    | 'marker_image'
    | 'thumbnail_gallery';
  sizes?: string;
  caption?: string;
};

export const mapImage = memoize(
  ({
    image,
    preset,
    sizes = '(min-width: 430px) 768px',
    caption,
  }: MapImageProps) => {
    const styles = [
      ...(image?.styles
        .filter((style) => style.id === preset)
        .map((style) => style.derivatives)[0] || []),
    ];

    const largest = styles.sort((a, b) => (a.width > b.width ? 1 : -1))[
      styles.length - 1
    ] as typeof styles[number] | undefined ;

    return buildImage({
      image: {
        backgroundColor: '#CCC',
        height: largest?.height || 0,
        width: largest?.width || 0,
        layout: 'constrained',
        images: {
          fallback: {
            src: assetUrl(largest?.url || ''),
            sizes,
            srcSet: styles
              .map((style) => `${assetUrl(style.url)} ${style.width}w`)
              .join(', '),
          },
        },
      },
      // If no alt text, fallback to image caption
      alt: (image?.alt as string) || caption || '',
    });
  },
  (params) => `${params.image?.cacheId}${params.preset}`,
);
